export const SITE_TITLE = 'Sigma Squared';
export const SUPPORT_EMAIL = 'support@sigma2.io';
